// React
import React from "react";

// Styles
import './dropdown.css';
import '../../assets/css/animations.css';

/*
 * Props 
 * @value : displayed valued in dropdown
 * @icon : 
 * @children : the list elements
 * @dropdownClasses
*/
const Dropdown = (props) => {

    const dropdownClass = props.icon != null ? 'dropdown yety-dropdown with-icon' : 'dropdown yety-dropdown';
    const caretClass = props.value != null ? 'caret' : 'caret pad-less';

    return (
        <div className={dropdownClass}>
            <a type="button" className="btn btn-link dropdown-toggle legitRipple" data-toggle="dropdown" aria-expanded="true"> 
                { props.icon == null ? null : <i className={props.icon}></i> }
                { props.value }
                <span className={caretClass}></span>
            </a>
            <ul className={"dropdown-menu " + props.dropdownClasses}>
            { props.children }
            </ul>
        </div>
    );


};

export default Dropdown;


// WEBPACK FOOTER //
// ./src/Components/Dropdown/Dropdown.js